// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e4e01b0e","455":"dc82efc5","977":"688b3562"}[chunkId] + ".chunk.js";
};